import gql from 'graphql-tag';
import { fileOperation } from '@shared/api/fragments/fileOperation';
import { EntityRefs } from '../fragments/entity';
import { FilterByComponent } from '../fragments/viewTemplate';
import { WorkflowEntity } from '../fragments/workflow';

export const createWorkflowEntity = gql`
  mutation CreateWorkflowEntityMutation($input: CreateWorkflowEntity!) {
    createWorkflowEntity(input: $input) {
      entity {
        ...WorkflowEntity
      }
    }
  }

  ${WorkflowEntity}
`;

export const createWorkflowEntities = gql`
  mutation CreateWorkflowEntitiesMutation($input: CreateWorkflowEntities!) {
    createWorkflowEntities(input: $input) {
      entities {
        ...WorkflowEntity
      }
    }
  }

  ${WorkflowEntity}
`;

export const deleteWorkflowEntities = gql`
  mutation DeleteWorkflowEntitiesMutation($input: DeleteWorkflowEntities!) {
    deleteWorkflowEntities(input: $input)
  }
`;

export const restoreWorkflowEntities = gql`
  mutation RestoreWorkflowEntitiesMutation($input: RestoreWorkflowEntities!) {
    restoreWorkflowEntities(input: $input)
  }
`;

export const updateWorkflowEntity = gql`
  mutation UpdateWorkflowEntityMutation($input: UpdateWorkflowEntity!) {
    updateWorkflowEntity(input: $input) {
      entity {
        ...WorkflowEntity
      }
    }
  }

  ${WorkflowEntity}
`;

export const updateWorkflowEntities = gql`
  mutation UpdateWorkflowEntitiesMutation($input: UpdateWorkflowEntities!) {
    updateWorkflowEntities(input: $input) {
      entities {
        ...WorkflowEntity
      }
      refs {
        ...EntityRefs
      }
    }
  }

  ${EntityRefs}
  ${WorkflowEntity}
`;

export const createRecurringEntities = gql`
  mutation CreateRecurringEntitiesMutation($input: CreateRecurringEntities!) {
    createRecurringEntities(input: $input) {
      schedule {
        createdAt
        updatedAt
        id
        name
        rrule
        workflowTemplateId
        dateComponentId
        extend {
          autoExtend {
            seriesFilter {
              ...FilterByComponent
            }
            minimumInSeries
          }
        }
        offset {
          value
          unit
          initialDate
          timezone
        }
      }
      workflowEntitiesResult {
        entities {
          ...WorkflowEntity
        }
        refs {
          recurringEntitiesScheduleRefs {
            id
            createdAt
            updatedAt
            name
            workflowTemplateId
            rrule
            dateComponentId
          }
        }
      }
    }
  }

  ${FilterByComponent}
  ${WorkflowEntity}
`;

export const getWorkflowEntitiesResult = gql`
  fragment GetWorkflowEntitiesResult on GetWorkflowEntitiesResult {
    entities {
      ...WorkflowEntity
    }
    refs {
      ...EntityRefs
    }
  }

  ${EntityRefs}
  ${WorkflowEntity}
`;

export const updateRecurringEntitiesV2 = gql`
  mutation UpdateRecurringEntitiesV2Mutation($input: UpdateRecurringEntities!) {
    updateRecurringEntitiesV2(input: $input) {
      ...GetWorkflowEntitiesResult
      ...FileOperation
    }
  }

  ${getWorkflowEntitiesResult}
  ${fileOperation}
`;

export const deleteRecurringEntitiesResult = gql`
  fragment DeleteRecurringEntitiesResult on DeleteRecurringEntitiesResult {
    deletedCount
  }
`;

export const deleteRecurringEntitiesV2 = gql`
  mutation DeleteRecurringEntitiesV2Mutation($input: DeleteRecurringEntities!) {
    deleteRecurringEntitiesV2(input: $input) {
      ...DeleteRecurringEntitiesResult
      ...FileOperation
    }
  }

  ${deleteRecurringEntitiesResult}
  ${fileOperation}
`;

export const moveWorkflowEntities = gql`
  mutation MoveWorkflowEntitiesMutation($input: MoveWorkflowEntities!) {
    moveWorkflowEntities(input: $input) {
      id
    }
  }
`;

export const bulkUpdateWorkflowEntities = gql`
  mutation CreateBatchUpdateWorkflowEntitiesFile($input: CreateBatchUpdateWorkflowEntitiesFile!) {
    createBatchUpdateWorkflowEntitiesFile(input: $input) {
      id
      name
      createdAt
      updatedAt
      folder
      contentType
    }
  }
`;
